import { useParentOrganisations } from 'api';

export type useGetManageOrganisationRecordsReturn = {
  searchMatchCount: number;
  totalCount: number;
};

export const useGetManageOrganisationRecords = (): useGetManageOrganisationRecordsReturn => {
  const { data: organisationSearch } = useParentOrganisations();

  const searchMatchCount = organisationSearch?.parentOrganisations.items.length ?? 0;
  const totalCount = organisationSearch?.paginationInfo.totalCount ?? 0;

  return {
    searchMatchCount,
    totalCount,
  };
};
